export default __webpack_public_path__ + "static/media/LogoLab.ccc8e13a.png";